import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNav from './BottomNav'
import Header from './Header'
import { titleFor } from '../../config/nav'

// Screens own their own horizontal padding, because Home's search band and the
// Orders filter row both need to run to the edge of the column while the text
// above them stays inset.
/**
 * `children` is for the one route that is not a layout child.
 *
 * `/orders/:orderId` has to decide between the signed-in screen and the shared view
 * before it renders anything, so it cannot sit under this as an `<Outlet />`. It renders
 * the shell itself and passes the page in. Every other route is unchanged and still
 * arrives through the outlet.
 */
export default function AppShell({ children }) {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = `${titleFor(pathname)} · Machi Express`
  }, [pathname])

  return (
    <div
      className="min-h-screen min-h-[100dvh] flex flex-col"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <Header />

      {/* The bottom bar is fixed, so the last row needs clearance under it —
          only on the phone, where the bar exists. */}
      <main className="flex-1 w-full max-w-[640px] mx-auto pb-[calc(58px+env(safe-area-inset-bottom))] md:pb-14">
        {children ?? <Outlet />}
      </main>

      <BottomNav />
    </div>
  )
}
